define('viewmodels/VisualAnalytics/ValidationReports',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'], function (ko, router, appsecurity, navigation, app, logger, system, utils) {
    var title = 'Validation Reports';
    var VRViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        RiskAreaList: ko.observableArray(),
        ClickedAssessmentType: ko.observable(),
        RiskAreaTabClick: RiskAreaTabClick,
        ClickedRiskAreaID: ko.observable(),
        RiskFactorList: ko.observableArray(),
        BusinessUnitsList: ko.observableArray(),
        TotalValuesList: ko.observableArray(),
        YOAList: ko.observableArray([]),
        ProfileList: ko.observableArray([]),
        profileSelected: ko.observable(),
        assessmentTabs: ko.observableArray([]),
        clickedAssessmentType: ko.observable(),
        riskTabs: ko.observableArray([]),
        AssessmentTabClick: AssessmentTabClick,
        CurrentYear: ko.observable(),
        CurrentYearofAssessment: ko.observable(),
        InherentRFDataList: ko.observableArray(),
        InherentRFDataListDup: ko.observableArray(),
        InherentRFDataListHeader: ko.observableArray(),
        InherentRFDataListHeaderRF: ko.observableArray(),
        SelectedYearofAssessment: ko.observable(),
        onChangeofYearofAssessment: onChangeofYearofAssessment,
        SelectedBuUnitsID: ko.observableArray([]),
        RefreshData: RefreshData,
        countEntry: ko.observable(0),
        ColspanValue: ko.observable(2)
    }

    return VRViewModel;

    function activate() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
            $('#BUSelector').multiselect();
            $('#NoDataerror').hide();
            // GetYearDropdown().then(function () {
            GetCurrentYearOfAssessment().then(function () {
                var options = {
                    url: "/api/Reporting/GetAllBusinessUnitsByProfileAssessment?profileId=" + VRViewModel.profileSelected(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                };
                getAllBusinessUnits(options).then(function () {
                    //    $('#RaTab').tabs();
                    //    $('#RaTab').tabs('refresh');
                    //    $('#RaTab').tabs({ active: 0 });
                    //    $($('#RiskAreaUl li').get(0)).trigger('click');
                    //    $('#RiskAreaTabDiv').tabs();
                });
            });
            // });

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    };
    function AssessmentTabClick(data, event) {
        VRViewModel.clickedAssessmentType(event.currentTarget.id);
        GetRiskFactors();
    }
    function RiskAreaTabClick(data, event) {
        VRViewModel.ClickedRiskAreaID(event.currentTarget.id);
        //GetRiskFactors().then(function () {
        // if (VRViewModel.SelectedBuUnitsID().length > 0) {
        $('#error').hide();
        $('#NoDataerror').hide();
        GetInhTotalData().then(function () {
          
        });
        //}
        //else {

        //}
        //});
    }
    function onChangeofYearofAssessment(data, event) {
        try {
            if (VRViewModel.countEntry() == 1) {
                var options = {
                    url: "/api/Reporting/GetAllBusinessUnitsByYearofAssessment?YearOfAssessment=" + VRViewModel.CurrentYear(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()

                }
                getAllBusinessUnits(options);
            }
            else {
                VRViewModel.countEntry(1);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Methodcall in onChangeofYearofAssessment() method in InherentHeatMapAnalysis.js';
            logger.logMessage(msg);
        }
    }
    function RefreshData() {
        if (VRViewModel.SelectedBuUnitsID().length > 0) {
            $('#error').hide();
            //GetAllRiskAreas().then(function () {
            //})
            GetRiskFactors();
        }
        else {
            $('#error').show();
        }
    }
    //Get functions
    function GetAllRiskAreas() {
        try {
            return $.ajax({
                url: "/api/Visualization/GetAllRiskAreas",
                data: { "AssessmentType": VRViewModel.ClickedAssessmentType(), "AreaType": "QUAN", "YOA": VRViewModel.CurrentYearofAssessment() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                //$('#loadingImgMain').remove();
                if (jsonResult != null) {
                    VRViewModel.RiskAreaList([]);
                    $('#RiskAreaTabDiv ul').empty();
                    if (jsonResult[0].RiskAreaId != 0) {
                        var mappedRiskAreaList = $.map(jsonResult, function (result) {
                            var RiskAreaModelObj = new RiskAreaModel(result);
                            addNewRaDivTab(RiskAreaModelObj);
                            return RiskAreaModelObj;
                        });
                        VRViewModel.RiskAreaList(mappedRiskAreaList);
                        scrollableTabs();
                        $($('#RiskAreaTab li').get(0)).trigger('click');
                    }
                    else {
                        $('#NoRiskAreaserror').show();
                        $('#RaTab').hide();
                    }

                }
                else
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(VRViewModel), true);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
    }

    function addNewRaDivTab(data) {
        try {
            $('#RiskAreaTabDiv ul').append(
                '<li id= "' + data.RiskAreaId() + '" aria-controls="RaTabDiv-' + data.RiskAreaId() + '" data-bind="click: $root.RiskAreaTabClick"><a class="short-tabs" id="AMLInhRaA-' + data.RiskAreaId() + '" href="#RaTabDiv-' + data.RiskAreaId() + '">' + data.RiskAreaName() + '</a></li>'
            );
            $('#RiskAreaTabDiv').append(
                '<div id="RaTabDiv-' + data.RiskAreaId() + '" style="overflow:hidden;"></div>');

            $('#RiskAreaTabDiv').tabs('refresh');
            $('#RiskAreaTabDiv').tabs({ active: 0 });

            ko.applyBindingsToNode($("#" + data.RiskAreaId()), { click: VRViewModel.RiskAreaTabClick }, VRViewModel);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewRaDivTab() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    }

    function GetRiskFactors() {
        try {
            GetAllRiskFactorAjax = {
                url: "/api/WeightingsThresholds/GetRiskAreas",
                data: { "AssessmentType": parseInt(VRViewModel.clickedAssessmentType()), "AssessmentProfile": VRViewModel.profileSelected() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            return $.ajax(GetAllRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskFactors() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult.length >= 1) {

                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            var RiskAreaModelObj = new RiskAreaModel(result);
                            return RiskAreaModelObj;
                        });
                        VRViewModel.riskTabs([]);
                        VRViewModel.riskTabs(mappedRiskFactors);
                        $('#RiskAreaTabsDiv').tabs();
                        $('#RiskAreaTabsDiv').tabs('refresh');
                        $('#RiskAreaTabsDiv').tabs({ active: 0 });
                        $($('#RiskAreaTabsUL li').get(0)).trigger('click');
                        $('#loadingMainImgDiv').hide();
                        $('#MainInherentHeatMapDiv').show();
                    }
                    else {
                        VRViewModel.RiskFactorList([]);
                        app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);

                    }
                } else {
                    VRViewModel.RiskFactorList([]);
                    app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactor() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }
    }

    function getAllBusinessUnits(options) {
        try {
            return $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnits() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {

                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {

                    VRViewModel.BusinessUnitsList([]);
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnitsModel(result);
                    });

                    VRViewModel.BusinessUnitsList(mappedBusinessUnits);
                    $('#BULoadingImgDiv').hide();
                    $('#BUSelector').multiselect("refresh");
                    $('#BUSelector').multiselect();
                    //$(".ui-multiselect-checkboxes > li > label").addClass("cc-checkbox");
                    $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                    $("#BULoadingImgDiv").hide();
                    VRViewModel.BusinessUnitsList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
    };

    function GetYearDropdown() {
        try {
            return $.ajax({
                url: "/api/Reporting/GetAllYearOfAssessment",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })

                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetYearDropdown() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length > 0) {
                    VRViewModel.YOAList(jsonResult);
                }
                else {
                    logger.logWarning('Business Units have not be configured for any year of assessment.', 'Success', system.getModuleId(VRViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetYearDropdown() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from GetYearDropdown() method in ValidationReports.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetYearDropdown() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

    }

    function GetInhTotalData() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            var abc = JSON.stringify($.map(VRViewModel.SelectedBuUnitsID(), function (result) {
                return { BU_ID: result };
            }));
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Visualization/GetValidationReportData?RiskAreaId=" + VRViewModel.ClickedRiskAreaID() + "&AssessmentType=" + VRViewModel.clickedAssessmentType() + "&AssessmentProfile=" + VRViewModel.profileSelected(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                data: JSON.stringify($.map(VRViewModel.SelectedBuUnitsID(), function (result) {
                    return { BU_ID: result };
                }))
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetInhTotalData() method in ValidationReports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == null) {
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(VRViewModel), true);
                }
                else if (jsonResult.ValidationResponseModelData.length == 0) {
                    VRViewModel.InherentRFDataList([]);
                    VRViewModel.InherentRFDataListDup([]);
                    $('#ValidationReportData').empty();
                    $('#NoDataerror').show();
                }
                else {
                    $('#NoDataerror').hide();
                    VRViewModel.InherentRFDataList([]);
                    VRViewModel.InherentRFDataListDup([]);

                    var mappedValidationResponseModelData = $.map(jsonResult.ValidationResponseModelData, function (result) {
                        return new ValidationResponseModel(result, 'D');
                    });
                    VRViewModel.InherentRFDataList(mappedValidationResponseModelData);

                    var mappedValidationResponseModelHeader = $.map(jsonResult.ValidationResponseModelHeader, function (result) {
                        return new ValidationResponseModel(result, 'H');
                    });
                    VRViewModel.InherentRFDataListHeader(mappedValidationResponseModelHeader);
                    VRViewModel.ColspanValue(VRViewModel.InherentRFDataListHeader().length);

                    var mappedValidationResponseModelHeaderBU = $.map(jsonResult.ValidationResponseModelHeaderBU, function (result) {
                        return new ValidationResponseModel(result, 'HBU');
                    });
                    VRViewModel.InherentRFDataListHeaderRF(mappedValidationResponseModelHeaderBU);
                    CreateTotalsTable();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetInhTotalData() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetInhTotalData() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetInhTotalData() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetCurrentYearOfAssessment() {
        try {
            return $.ajax({
                url: "/api/Account/GetCurrentProfileAssessmentList",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentYearOfAssessment() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.profileItem.length > 0) {
                    var mappedProfileList = $.map(jsonResult.profileItem, function (item) {
                        return new profileList(item);
                    });
                    VRViewModel.ProfileList(mappedProfileList);
                    var selectedProfile = ko.utils.arrayFilter(VRViewModel.ProfileList(), function (parameter) {
                        return parameter.status() == "A";
                    });
                    if (selectedProfile.length == 1 && selectedProfile)
                        VRViewModel.profileSelected(selectedProfile[0].ID());

                    var mappedAssessmentList = $.map(jsonResult.assessmentItem, function (item) {
                        return new assessmentTypeList(item);
                    });
                    VRViewModel.assessmentTabs(mappedAssessmentList);
                    $('#AssessmentTabsdiv').tabs();
                    $('#AssessmentTabsdiv').tabs('refresh');
                    $('#AssessmentTabsdiv').tabs({ active: 0 });
                    $($('#AssessmentTabsdivUl li').get(0)).trigger('click');
                    scrollableTabs();

                }
                else
                    logger.logError('An error occurred while fetching the Current Year of Assessment. Please contact your Administrator', 'Error', system.getModuleId(VRViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }
    }
    //-------------------------------------------------------------------------------------------->
    //this creates the table that will be binded to the html dynamically

    function CreateTotalsTable() {
        try {
            var TotalsTableHTML =

                '<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 well well-sm">' +
                '<label class="alert alert-danger field-validation-error" id="lblValidation" style="display:none">*Totals are not available.</label>' +
                '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 no-padding">' +

                '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 no-padding-right"><div class="pull-right">' +


                '</div></div>' +
                '</div>' +

                //Corner cell
                '<div class="clscroll corner-header">' +
                '<table style="width:100%">' +
                '<tr>' +
                '<th colspan="2" class="site_name label-success vertical-Align-top;" style="height:4em;"><span class="glyphicon glyphicon-arrow-right"></span>Business Units</th>' +
                '</tr>' +
                '<tr>' +
                '<th class="site_name label-info headcol-min1 text-center" title="Risk Factor Name" style="height:2.3em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Factor Name</th>' +

                '</tr>' +
                '</table>' +
                '</div>' +
                //Corner cell end

                //Header Business units
                '<div class="clscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + VRViewModel.ClickedRiskAreaID() + '" style="width:65%;">' +
                '<table>' +
                '<tr>'
            for (var i = 0, j = VRViewModel.SelectedBuUnitsID().length; i < j; i++) {
                for (var p = 0, q = VRViewModel.BusinessUnitsList().length; p < q; p++) {
                    if ((VRViewModel.SelectedBuUnitsID()[i] == VRViewModel.BusinessUnitsList()[p].BusinessUnit_ID())) {
                        TotalsTableHTML += '<th class="site_name long label-info" style="height:4em;" colspan="' + VRViewModel.ColspanValue() + '" title="' + VRViewModel.BusinessUnitsList()[p].BusinessUnit_Name() + '">' + VRViewModel.BusinessUnitsList()[p].BusinessUnit_Name() + '</th>';
                    }
                }
            }
            TotalsTableHTML += '</tr>' +
                '<tr>'
            for (var i = 0, j = VRViewModel.SelectedBuUnitsID().length; i < j; i++) {
                for (var p = 0, q = VRViewModel.InherentRFDataListHeader().length; p < q; p++) {
                    TotalsTableHTML += '<th class="site_name alert alert-warning-header long-min1" style="height:2.3em !important;">' + VRViewModel.InherentRFDataListHeader()[p].QRTD_RESPONSE() + '</th>';
                }

            }
            TotalsTableHTML += '</tr>' +
                '</table>' +
                '</div>' +

                //Header Business units end

                //Row headers
                '<div class="clscroll-row row-headers" id="clscroll-row-headers' + VRViewModel.ClickedRiskAreaID() + '" style="width:100%">' +
                '<table>';
            for (var i = 0, j = VRViewModel.InherentRFDataListHeaderRF().length; i < j; i++) {
                var length = parseInt(VRViewModel.InherentRFDataListHeaderRF()[i].ERF_NAME().length);
                var height = parseInt(Math.ceil(parseInt(Math.ceil(length / 30)) * 2.1));

                TotalsTableHTML += '<tr id="amlra-' + VRViewModel.ClickedRiskAreaID() + '-' + i + '">';
                TotalsTableHTML += '<td style="display:none">' + VRViewModel.InherentRFDataListHeaderRF()[i].ERF_UID() + '</td>';
                TotalsTableHTML += '<td class="headcol-min1" style="height:' + height + 'em;" title="' + VRViewModel.InherentRFDataListHeaderRF()[i].ERF_NAME() + '">' + VRViewModel.InherentRFDataListHeaderRF()[i].ERF_NAME() + '</td>';

            }
            TotalsTableHTML += '</table></div>' +
                //Row headers end

                //Data 
                '<div class="clscroll table-content" id="clscroll-content' + VRViewModel.ClickedRiskAreaID() + '" style="overflow-x:visible;">' +
                '<table>';
            for (var i = 0, j = VRViewModel.InherentRFDataListHeaderRF().length; i < j; i++) {
                var length = parseInt(VRViewModel.InherentRFDataListHeaderRF()[i].ERF_NAME().length);
                var height = parseInt(Math.ceil(parseInt(Math.ceil(length / 30)) * 2.1));

                TotalsTableHTML += '<tr>';
                for (var x = 0, y = VRViewModel.SelectedBuUnitsID().length; x < y; x++) {
                    var counter = 0;
                    for (var c = 0, d = VRViewModel.InherentRFDataListHeader().length; c < d; c++) {
                        for (var a = 0, b = VRViewModel.InherentRFDataList().length; a < b; a++) {
                            if ((VRViewModel.InherentRFDataListHeaderRF()[i].ERF_UID() == VRViewModel.InherentRFDataList()[a].ERF_UID()) && (VRViewModel.SelectedBuUnitsID()[x] == VRViewModel.InherentRFDataList()[a].DE_UID())&& (VRViewModel.InherentRFDataListHeader()[c].QSR_QRTD_UID() == VRViewModel.InherentRFDataList()[a].QSR_QRTD_UID())) {
                                counter++;
                               
                                var backgroungColor = VRViewModel.InherentRFDataList()[a].FLAG() == 0 ? '#53565A' : '#D0D0CE';
                                var bgcolor = 'background-color:' + backgroungColor +';color:'+( VRViewModel.InherentRFDataList()[a].FLAG() == 0 ?  '#D0D0CE': '#53565A');
                                //if(VRViewModel.InherentRFDataList()[a].QRTD_APPLICABILITY()== 1)
                                TotalsTableHTML += '<td id="' + VRViewModel.InherentRFDataList()[a].ERF_UID() + '_vol' + VRViewModel.InherentRFDataList()[a].DE_UID() + '" class="site_name long-min1 text-Custom ' + VRViewModel.InherentRFDataList()[a].FLAG() + '" style="height:' + height + 'em;' + bgcolor + '" title="' + VRViewModel.InherentRFDataList()[a].SUM() + '">' + VRViewModel.InherentRFDataList()[a].SUM() + '</td>';  
                                //else
                                //TotalsTableHTML += '<td id="' + VRViewModel.InherentRFDataList()[a].ERF_UID() + '_vol' + VRViewModel.InherentRFDataList()[a].DE_UID() + '" class="site_name long-min1 text-Custom ' + VRViewModel.InherentRFDataList()[a].FLAG() + '" style="height:' + height + 'em;background-color:black;color:white" title="' + VRViewModel.InherentRFDataList()[a].SUM() + '">NA</td>';
  
                                console.log(TotalsTableHTML);
                            }
                        }
                    }               
                    if (counter == 0) {
                        for (var c = 0, d = VRViewModel.InherentRFDataListHeader().length; c < d; c++) {
                            TotalsTableHTML += '<td style="height:' + height + 'em;" class="site_name long-min1 text-center"> - </td>';
                        }
                    }
                }
                TotalsTableHTML += '</tr>';
            }

            TotalsTableHTML += '</table></div>';
            //Data ends

            var cahcedScrollLeft = $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft();

            $('#ValidationReportData').empty();
            $('#ValidationReportData').prepend(TotalsTableHTML);
            //$('#ValidationReportData' + VRViewModel.ClickedRiskAreaID()).empty();
            //$('#' + VRViewModel.ClickedRiskAreaID()).prepend(TotalsTableHTML.replace(/;/g, ''));
            $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft(cahcedScrollLeft);
            $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#clscroll-row-headers" + VRViewModel.ClickedRiskAreaID()).scrollTop($("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollTop());
                $("#clscroll-column-headers" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
                $("#clscroll-column-footer" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });

            $("#clscroll-column-headers" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#clscroll-column-headers" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });

            $("#clscroll-column-footer" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#clscroll-column-footer" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });

            $("#clscroll-row-headers" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollTop($("#clscroll-row-headers" + VRViewModel.ClickedRiskAreaID()).scrollTop());
            });

            $("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#scrolldiv" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#clscroll-content" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });

            $("#innerdiv-" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#scrolldiv" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#innerdiv-" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });

            $("#scrolldiv" + VRViewModel.ClickedRiskAreaID()).scroll(function () {
                $("#innerdiv-" + VRViewModel.ClickedRiskAreaID()).scrollLeft($("#scrolldiv" + VRViewModel.ClickedRiskAreaID()).scrollLeft());
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CreateTotalsTable() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    }

    //------------Model Definition
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RISK_AREA_NAME).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RISK_AREA_UID).text());

            self.RiskArea = ko.observable(item.RISK_AREA_NAME);
            self.RiskId = ko.observable(item.RISK_AREA_UID);
            self.IsQualitative = ko.observable(false);
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    };
    function profileList(item) {
        var self = this;
        self.ID = ko.observable(item.ID);
        self.profileName = ko.observable(item.profileName);
        self.status = ko.observable(item.status);
    };
    function assessmentTypeList(item) {
        var self = this;
        self.ID = ko.observable(item.ID);
        self.assessmentTypeDesc = ko.observable(item.assessmentType + ' Inherent Risk Validations');
        self.assessmentType = ko.observable(item.assessmentType);
    }
    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    };
    function BusinessUnitsModel(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BU_ID);
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.businessUnitCleanName).text());
            //self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            //self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            //self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    }
    function ValidationResponseModel(item, char) {
        var self = this;
        if (char == 'D') {
            self.ERF_UID = ko.observable(item.ERF_UID);
            self.ERF_NAME = ko.observable(item.ERF_NAME);
            self.DE_UID = ko.observable(item.DE_UID);
            self.DE_ORIG_NAME = ko.observable(item.DE_ORIG_NAME);
            self.FLAG = ko.observable(item.FLAG);
            self.SUM = ko.observable(item.SUM);
            self.QSR_QRTD_UID = ko.observable(item.QSR_QRTD_UID);
            self.QRTD_RESPONSE = ko.observable(item.QRTD_RESPONSE);
            self.QRTD_APPLICABILITY = ko.observable(item.QRTD_APPLICABILITY);
        }
        if (char == 'H') {
            self.QSR_QRTD_UID = ko.observable(item.QSR_QRTD_UID);
            self.QRTD_RESPONSE = ko.observable(item.QRTD_RESPONSE);
        }
        if (char == 'HBU') {
            self.ERF_UID = ko.observable(item.ERF_UID);
            self.ERF_NAME = ko.observable(item.ERF_NAME);
        }
    }
    function YearofAssessmentModel(item) {
        try {
            var self = this;
            self.YearofAssessment = ko.observable(item.YearofAssessment);
            self.ConfigStatus = ko.observable(item.ConfigStatus);
            self.CalculationStatus = ko.observable(item.CalculationStatus);
            self.FreezeStatus = ko.observable(item.FreezeStatus);
            self.ConfigurationFreezeFlag = ko.observable(item.ConfigurationFreezeFlag)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: YearofAssessmentModel() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    }
});



































